export default __webpack_public_path__ + "static/media/hd.0adac2cd.svg";